import './quiz.js';

(function () {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'fbclid', 'loc_id'];

  function isMacro(v) { return /^\{.*\}$/.test(v || ''); }

  function captureCampaign() {
    var qs;
    try { qs = new URLSearchParams(location.search); } catch (e) { return; }
    UTM_KEYS.forEach(function (k) {
      var v = qs.get(k);
      if (v && !isMacro(v) && v.length <= 300) {
        try { sessionStorage.setItem(k, String(v)); } catch (e) { }
      }
    });
  }
  captureCampaign();

  window.ADVOKAT_CAMPAIGN = function () {
    var store = {};
    UTM_KEYS.forEach(function (k) {
      var v;
      try { v = sessionStorage.getItem(k); } catch (e) { v = null; }
      if (v) { store[k] = v; }
    });
    return store;
  };

  function track(event, data) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: event }, data || {}));
  }

  function onTelClick() {
    var now = Date.now(), last = 0;
    try { last = parseInt(sessionStorage.getItem('ap_tel_ts') || '0', 10); } catch (e) { }
    if (now - last > 30 * 60 * 1000) {
      track('tel_click', {});
      try { sessionStorage.setItem('ap_tel_ts', String(now)); } catch (e) { }
    }
  }
  $$('.js-tel').forEach(function (a) { a.addEventListener('click', onTelClick); });

  var body = document.body;
  var hotBlock = $('.hot');
  var stickyBar = $('#stickyBar');
  var MQ_DESKTOP = window.matchMedia('(min-width: 901px)');

  var scrolledPastHot = false;
  var quizBlocksSticky = false;

  function refreshSticky() {
    var show = !MQ_DESKTOP.matches && scrolledPastHot && !quizBlocksSticky;
    body.classList.toggle('sticky-on', show);
    if (stickyBar) { stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true'); }
  }

  function checkScroll() {
    if (!hotBlock) { return; }
    var r = hotBlock.getBoundingClientRect();
    scrolledPastHot = r.bottom < 0;
    refreshSticky();
  }

  window.addEventListener('scroll', checkScroll, { passive: true });
  window.addEventListener('resize', checkScroll);
  if (MQ_DESKTOP.addEventListener) { MQ_DESKTOP.addEventListener('change', refreshSticky); }
  window.addEventListener('load', checkScroll);
  checkScroll();

  document.addEventListener('advokat:quiz-state', function (e) {
    var detail = e.detail || {};
    quizBlocksSticky = !!detail.isFinal || !!detail.done;
    refreshSticky();
  });
})();